import AgencyHelper, { AgencyConstants } from "features/Agency/agencyHelper";
import DealerHelper from "features/ManageDealer/dealerHelper";
import ReconciliationReportHelper from "features/ReconciliationReport/ReconciliationReportHelper";
import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from "general/components/OtherKeenComponents/KTBSButton";
import KTLabel, { KTLabelSize } from "general/components/OtherKeenComponents/KTLabel";
import CustomCard from "general/components/Others/CustomCard";
import VITableRowDropDown from "general/components/VITableRowDropDown";
import AppColors from "general/constants/AppColors";
import Utils from "general/utils/Utils";
import useRouter from "hooks/useRouter";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AgencyReconciliationChartView from "../../components/AgencyReconciliationChartView";
import NewAgenciesListView from "../../components/NewAgenciesListView";
import AppConfigs from "general/constants/AppConfigs";
import AppTabs from "general/components/AppTabs";
import { AnimatePresence, motion } from 'framer-motion';
import agencyApi from "api/agencyApi";
import { AppCustomDialogHelper } from "general/components/AppDialogCustom";
import DialogEditReconciliationView from "../../components/DialogEditReconciliationView";
import BreadcrumbHelper from "general/components/CustomBreadcrumb/BreadcrumbHelper";
import ToastHelper from "general/helpers/ToastHelper";
import UIHelper from "general/helpers/UIHelper";
import _ from "lodash";
import AppConstants from "general/constants/AppConstants";
import PropTypes from "prop-types";
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';

SaleReconciliationDetailView.propTypes = {
    primaryRole: PropTypes.string,
};

function SaleReconciliationDetailView(props) {
    // MARK: ---- PROPERTIES ----
    const { primaryRole } = props;
    const router = useRouter();
    const { t } = useTranslation();
    const reconciliationId = router?.query?.reconciliationId;
    const agencyId = router?.query?.agencyId;
    const [reconciliationDetail, setReconciliationDetail] = useState(null);
    const [agencyDetail, setAgencyDetail] = useState(null);
    const [investorResultDetail, setInvestorResultDetail] = useState(null);
    const [coinvestorResultDetail, setCoinvestorResultDetail] = useState(null);
    const [saleResultDetail, setSaleResultDetail] = useState(null);
    const [packageResultDetail, setPackageResultDetail] = useState(null);
    const [referralResultDetail, setReferralResultDetail] = useState(null);
    const [investorEnergyResultDetail, setInvestorEnergyResultDetail] = useState(null);
    const [coinvestorEnergyResultDetail, setCoinvestorEnergyResultDetail] = useState(null);
    const [premiseEnergyResultDetail, setPremiseEnergyResultDetail] = useState(null);
    const [chargePointResultDetail, setChargePointResultDetail] = useState(null);
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());
    const { user } = useSelector((state) => state.auth);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const isOrganizationAgency = useMemo(() => {
        return reconciliationDetail?.agency?.type === 'ORGANIZATION';
    }, [reconciliationDetail]);

    useEffect(() => {
        handleGetSaleReconciliationDetail();
    }, [reconciliationId, agencyId]);

    const handleGetSaleReconciliationDetail = () => {
        if (reconciliationId) {
            AgencyHelper.API.requestGetReconciliationDetail(reconciliationId).then(
                (reconciliationDetail) => {
                    setReconciliationDetail(reconciliationDetail);
                    setAgencyDetail(reconciliationDetail?.agency);
                    setInvestorResultDetail(reconciliationDetail?.metadata?.investor_results);
                    setCoinvestorResultDetail(reconciliationDetail?.metadata?.coinvestor_results);
                    setPackageResultDetail(reconciliationDetail?.metadata?.package_results);
                    setReferralResultDetail(reconciliationDetail?.metadata?.referral_results);
                    setChargePointResultDetail(reconciliationDetail?.metadata?.chargepoint_results);
                    setInvestorEnergyResultDetail(reconciliationDetail?.metadata?.investor_energy_results);
                    setCoinvestorEnergyResultDetail(reconciliationDetail?.metadata?.coinvestor_energy_results);
                    setPremiseEnergyResultDetail(reconciliationDetail?.metadata?.premise_energy_results);
                    setSaleResultDetail(reconciliationDetail?.metadata?.sale_results);
                }
            );
        } else if (agencyId) {
            const paramGetReconciliationList = {
                agencyId,
            };
            AgencyHelper.API.requestGetReconciliationList(paramGetReconciliationList).then(
                (reconciliationList) => {
                    setReconciliationDetail(_.maxBy(reconciliationList, 'reconciliationId'));
                }
            );
        }
    }

    useEffect(() => {
        if (reconciliationDetail?.month) {
            const match = reconciliationDetail.month.match(/^(\d{4})-(\d{2})$/);
            if (match) {
                const [, year, month] = match;
                setYear(Number(year));
                setMonth(Number(month));
            }
        }
    }, [reconciliationDetail]);

    const [selectedTab, setSelectedTab] = useState(t('Đại lý mới'));
    useEffect(() => {
        if (primaryRole === 'SALE') {
            setSelectedTab('Đại lý mới')
        } else {
            setSelectedTab('Nhà đầu tư mới')
        }
    }, [primaryRole])
    const tabs = useMemo(() => {
        if (primaryRole == 'SALE') {
            return [
                'Đại lý mới',
                'NĐT và chủ mặt bằng mới',
            ].reverse();
        } else {
            return [
                'NĐT và chủ mặt bằng mới',
            ].reverse();
        }
    }, [primaryRole]);

    const handleSelectedTab = (newTab) => {
        if (selectedTab === newTab) return;
        if (primaryRole === 'SALE') {
            if (newTab === 'Đại lý mới') {
                router.navigate('#new-sales');
            }
            if (newTab === 'NĐT và chủ mặt bằng mới') {
                router.navigate('#new-agencies');
            }
        } else {
            const { parent } = Utils.parseHash(hash) || {};
            let childValue = '';

            if (newTab === 'NĐT và chủ mặt bằng mới') {
                childValue = 'new-agencies';
            }

            const newHash = `#parent=${parent || 'investor-reconciliation'}&child=${childValue}`;
            router.navigate(newHash);
        }
        setSelectedTab(newTab);
    };

    const hash = router?.location?.hash;

    useEffect(() => {
        if (primaryRole === 'SALE') {
            if (hash === '#new-sales') setSelectedTab(t('Đại lý mới'));
            if (hash === '#new-agencies') setSelectedTab('NĐT và chủ mặt bằng mới');
        } else {
            const { child } = Utils.parseHash(hash);
            if (child === 'new-agencies') setSelectedTab('NĐT và chủ mặt bằng mới');
        }
    }, [hash]);

    const newSalesListView = useMemo(() => {
        return (
            <NewAgenciesListView
                agencyRole='SALE'
                reconciliationDetail={reconciliationDetail}
            />
        );
    }, [reconciliationDetail]);

    const newAgenciesListView = useMemo(() => {
        return (
            <NewAgenciesListView
                agencyRole='INVESTOR,GROUP,COINVESTOR,LANDLORD'
                reconciliationDetail={reconciliationDetail}
            />
        );
    }, [reconciliationDetail]);

    const chartInfoList = useMemo(() => {
        if (!reconciliationDetail) {
            return [];
        }
        const saleLabels = ReconciliationReportHelper.formatSaleByDate(investorResultDetail?.saleByDate, year, month)?.map(sale => sale?.date);
        const saleData = ReconciliationReportHelper.formatSaleByDate(investorResultDetail?.saleByDate, year, month)?.map(sale => sale?.amount);

        const coinvestorLabels = ReconciliationReportHelper.formatSaleByDate(coinvestorResultDetail?.saleByDate, year, month)?.map(sale => sale?.date);
        const coinvestorData = ReconciliationReportHelper.formatSaleByDate(coinvestorResultDetail?.saleByDate, year, month)?.map(sale => sale?.amount);

        const groupLabels = ReconciliationReportHelper.formatSaleByDate(packageResultDetail?.saleByDate, year, month)?.map(sale => sale?.date);
        const groupData = ReconciliationReportHelper.formatSaleByDate(packageResultDetail?.saleByDate, year, month)?.map(sale => sale?.amount);

        const landlordLabels = ReconciliationReportHelper.formatReferralByDate(referralResultDetail?.referralsByDate, year, month)?.map(sale => sale?.date);
        const landlordData = ReconciliationReportHelper.formatReferralByDate(referralResultDetail?.referralsByDate, year, month)?.map(sale => sale?.commission);

        const chargePointLabels = ReconciliationReportHelper.formatSaleByDate(chargePointResultDetail?.saleByDate, year, month)?.map(sale => sale?.date);
        const chargePointData = ReconciliationReportHelper.formatSaleByDate(chargePointResultDetail?.saleByDate, year, month)?.map(sale => sale?.amount);
        return [
            // {
            //     title: 'Doanh thu bán gói đầu tư HTKD',
            //     labels: groupLabels,
            //     data: groupData,
            //     color: '#9385F2',
            //     backgroundColor: "#E3DFFF",
            //     valueInfoList: [
            //         { name: 'Số đơn hàng', value: packageResultDetail?.totalSale, unit: '' },
            //         { name: 'Số doanh thu', value: Math.round(packageResultDetail?.amountSale), unit: 'VNĐ' },
            //         { name: 'Tỷ lệ chia sẻ', value: packageResultDetail?.amountSale ? (packageResultDetail?.basicSaleCommission / packageResultDetail?.amountSale) * 100 : 0, unit: '%' },
            //         { name: 'Số tiền hoa hồng', value: Math.round(packageResultDetail?.basicSaleCommission), unit: 'VNĐ' },
            //     ]
            // },
            {
                title: 'Doanh thu bán nhượng quyền',
                labels: saleLabels,
                data: saleData,
                color: '#2984EE',
                backgroundColor: "#C7E0FF",
                valueInfoList: [
                    { name: 'Số đơn hàng', value: investorResultDetail?.totalSale, unit: '' },
                    { name: 'Số doanh thu', value: Math.round(investorResultDetail?.amountSale ?? 0), unit: 'VNĐ' },
                    { name: 'Tỷ lệ chia sẻ', value: investorResultDetail?.amountSale ? (investorResultDetail?.basicSaleCommission / investorResultDetail?.amountSale) * 100 : 0, unit: '%' },
                    { name: 'Số tiền hoa hồng', value: Math.round(investorResultDetail?.basicSaleCommission ?? 0), unit: 'VNĐ' },
                ]
            },
            {
                title: 'Doanh thu bán liên kết',
                labels: coinvestorLabels,
                data: coinvestorData,
                color: '#DD4B92',
                backgroundColor: "#FBE7F0",
                valueInfoList: [
                    { name: 'Số đơn hàng', value: coinvestorResultDetail?.totalSale, unit: '' },
                    { name: 'Số doanh thu', value: Math.round(coinvestorResultDetail?.amountSale ?? 0), unit: 'VNĐ' },
                    { name: 'Tỷ lệ chia sẻ', value: coinvestorResultDetail?.amountSale ? (coinvestorResultDetail?.basicSaleCommission / coinvestorResultDetail?.amountSale) * 100 : 0, unit: '%' },
                    { name: 'Số tiền hoa hồng', value: Math.round(coinvestorResultDetail?.basicSaleCommission ?? 0), unit: 'VNĐ' },
                ]
            },
            // {
            //     title: 'Doanh thu môi giới tìm kiếm mặt bằng',
            //     labels: landlordLabels,
            //     data: landlordData,
            //     color: '#FF9500',
            //     backgroundColor: "#FFEACA",
            //     valueInfoList: [
            //         { name: 'Số đơn hàng', value: referralResultDetail?.totalReferrals, unit: '' },
            //         { name: 'Hoa hồng mặt bằng', value: Math.round(_.sum(landlordData)), unit: 'VNĐ' },
            //         { name: 'Hoa hồng tiền điện mặt bằng', value: Math.round(referralResultDetail?.totalReferralCommission - _.sum(landlordData)), unit: 'VNĐ' },
            //     ]
            // },
            // {
            //     title: 'Doanh thu môi giới khách hàng mua trụ sạc',
            //     labels: chargePointLabels,
            //     data: chargePointData,
            //     color: '#42D1B5',
            //     backgroundColor: "#D4F4ED",
            //     valueInfoList: [
            //         { name: 'Số đơn hàng', value: chargePointResultDetail?.totalSale, unit: '' },
            //         { name: 'Số doanh thu', value: Math.round(chargePointResultDetail?.amountSale), unit: 'VNĐ' },
            //         { name: 'Tỷ lệ chia sẻ', value: chargePointResultDetail?.amountSale ? (chargePointResultDetail?.basicSaleCommission / chargePointResultDetail?.amountSale) * 100 : 0, unit: '%' },
            //         { name: 'Số tiền hoa hồng', value: Math.round(chargePointResultDetail?.basicSaleCommission), unit: 'VNĐ' },
            //     ]
            // },
        ];
    }, [reconciliationDetail, investorResultDetail, coinvestorResultDetail, packageResultDetail, referralResultDetail, chargePointResultDetail, year, month]);
    const SaleReconciliationInfo = () => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex align-items-center w-100 p-0">
                    <div className="d-flex flex-column w-100">
                        <div className="d-flex align-items-center gap-2" style={{ overflow: 'hidden' }}>
                            <div
                                className="font-weight-bolder"
                                style={{
                                    color: AppColors.gray[800],
                                    fontSize: Utils.returnFontSize(18),
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {agencyDetail?.name}{" "}
                                • {agencyDetail?.agencyCode ?? DealerHelper.formatDealerCode(agencyDetail?.agencyId)}
                            </div>

                            <span className="min-w-100px ml-3">
                                <KTLabel
                                    text={ReconciliationReportHelper.getReconciliationStatusName(reconciliationDetail?.status)}
                                    isInline={true}
                                    size={KTLabelSize.medium}
                                    additionalClassName={`label-light-${ReconciliationReportHelper.getReconciliationStatusColor(
                                        reconciliationDetail?.status
                                    )}`}
                                />
                            </span>
                        </div>
                        <div style={{ fontSize: Utils.returnFontSize(14), color: AppColors.gray[700] }}>
                            Đối soát doanh thu {AgencyHelper.Utils.getShortAgencyRoleName(primaryRole).toLowerCase()} tháng {Utils.formatDateTimeToString(reconciliationDetail?.month, 'MM/yyyy')}
                        </div>
                    </div>

                    <div className="d-flex gap-3">
                        {!adminRole && reconciliationDetail?.status === 'ADMIM_SIGNED' &&
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title={t('Ký đối soát')}
                                size={KTBSButtonSize.default}
                                borderRadius={5}
                                buttonTitleFontWeight="600"
                                onPress={() => ReconciliationReportHelper.handleAgencySignReconciliation(reconciliationDetail, handleGetSaleReconciliationDetail)}
                                height={43}
                                buttonTitleFontSize={14}
                            />
                        }
                        {adminRole && reconciliationDetail?.status === 'CREATED' &&
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title={t('Duyệt & ký đối soát')}
                                size={KTBSButtonSize.default}
                                borderRadius={5}
                                buttonTitleFontWeight="600"
                                onPress={() => ReconciliationReportHelper.handleAdminSignReconciliation(reconciliationDetail, handleGetSaleReconciliationDetail)}
                                height={43}
                                buttonTitleFontSize={14}
                            />
                        }
                        <VITableRowDropDown
                            toggleElement={
                                <a
                                    href="#"
                                    className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                                    style={{ backgroundColor: AppColors.gray[200] }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <i
                                        className="fa-solid fa-ellipsis"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    />
                                </a>
                            }
                            menuItem={[
                                {
                                    iconElement: <i className="fa-regular fa-pen-to-square"></i>,
                                    text: t('edit'),
                                    click: () => {
                                        AppCustomDialogHelper.show(
                                            `Sửa đối soát tháng ${Utils.formatDateTimeToString(reconciliationDetail?.month, 'MM/YYYY')}`,
                                            <DialogEditReconciliationView
                                                item={reconciliationDetail}
                                                onCancel={() => {
                                                    AppCustomDialogHelper.hide();
                                                }}
                                                onDone={() => {
                                                    ToastHelper.showSuccess('Cập nhật đối soát thành công!')
                                                    AppCustomDialogHelper.hide();
                                                    handleGetSaleReconciliationDetail();
                                                }}
                                            />,
                                            'md',
                                            true,
                                            true
                                        )
                                    },
                                    show: adminRole && (reconciliationDetail?.reconciliationType === 'PAPER' && reconciliationDetail?.status === 'COMPLETED'),
                                },
                                {
                                    iconElement: <i className="fa-regular fa-memo-circle-info"></i>,
                                    text: 'Đơn hàng liên quan',
                                    click: () => {
                                        if (!adminRole) {
                                            router.navigate(`/order?month=${reconciliationDetail?.month}`);
                                        } else {
                                            router.navigate(`/order?agencyId=${reconciliationDetail?.agency?.agencyId}&month=${reconciliationDetail?.month}`);
                                        }
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: <i className="fa-regular fa-file-chart-column"></i>,
                                    text: t('Xem file đối soát'),
                                    click: () => {
                                        if (Utils.isValid(reconciliationDetail?.document)) {
                                            Utils.openInNewTab(Utils.getFullUrl(reconciliationDetail?.document));
                                        }
                                    },
                                    show: !!reconciliationDetail?.document,

                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-arrow-rotate-left"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tạo lại đối soát',
                                    click: () => {
                                        AgencyHelper.UI.showDialogCreateReconciliation('SALE', reconciliationDetail, handleGetSaleReconciliationDetail)
                                    },
                                    show: adminRole
                                        && [
                                            AgencyConstants.AgencyReconciliationStatus.CREATED,
                                            AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED,
                                        ].includes(reconciliationDetail?.status),
                                },
                                {
                                    iconElement: <i className="far fa-download"></i>,
                                    text: t('Tải đối soát excel'),
                                    click: () => Utils.openInCurrentTab(reconciliationDetail?.documentXLSX),
                                    show: !!reconciliationDetail?.documentXLSX,

                                },
                                {
                                    iconElement: <i className="far fa-message-exclamation"></i>,
                                    text: 'Gửi phản hồi',
                                    click: () => ReconciliationReportHelper.showDialogReconciliationFeedback(reconciliationDetail, adminRole, handleGetSaleReconciliationDetail),
                                    show: !adminRole && reconciliationDetail?.status !== 'AGENCY_SIGNED',
                                },
                                {
                                    iconElement: <i className="far fa-message-exclamation"></i>,
                                    text: 'Xem phản hồi',
                                    click: () => ReconciliationReportHelper.showDialogReconciliationFeedback(reconciliationDetail, adminRole, handleGetSaleReconciliationDetail),
                                    show: adminRole && !!reconciliationDetail?.feedback,
                                },
                                {
                                    iconElement: <i className="far fa-file-check"></i>,
                                    text: 'Duyệt hóa đơn thuế',
                                    click: () => ReconciliationReportHelper.showDialogApprovalInvoice(reconciliationDetail, adminRole, handleGetSaleReconciliationDetail),
                                    show: adminRole && reconciliationDetail?.agency?.type === 'ORGANIZATION' && reconciliationDetail?.status === 'AGENCY_SIGNED' && !!reconciliationDetail?.attachedFiles?.length,
                                },
                                {
                                    iconElement: <i className="far fa-upload"></i>,
                                    text: 'Tải lên hóa đơn thuế',
                                    click: () => ReconciliationReportHelper.showDialogUploadInvoiceDocument(reconciliationDetail, handleGetSaleReconciliationDetail),
                                    show: reconciliationDetail?.agency?.type === 'ORGANIZATION' && reconciliationDetail?.status === 'AGENCY_SIGNED',
                                },
                            ]}
                            singleBtnBgColor={AppColors.gray[200]}
                        />
                    </div>
                </div>
            </div>
        );
    };

    const ReconciliationInfo = ({ textHeader = [], contents }) => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex align-items-center w-100 p-0 mb-2">
                    <div>
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>Thông tin đối soát</div>
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                Tổng:{' '}
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                    {Utils.formatNumber(_.sum([
                                        saleResultDetail?.totalSale ?? 0,
                                        coinvestorResultDetail?.totalSale ?? 0,
                                    ]))}
                                </span>
                            </span>
                            <span style={{ color: AppColors.gray[400] }}>•</span>
                            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                NĐT nhượng quyền:{' '}
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                    {Utils.formatNumber(saleResultDetail?.totalSale ?? 0)}
                                </span>
                            </span>
                            <span style={{ color: AppColors.gray[400] }}>•</span>
                            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                NĐT liên kết:{' '}
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                    {Utils.formatNumber(coinvestorResultDetail?.totalSale ?? 0)}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div className="rounded-lg p-0" style={{ border: "1px solid #EBEDEF" }}>
                    <table className="w-100" style={{ borderCollapse: "collapse" }}>
                        <thead>
                            <tr
                                className="font-weight-bolder p-3"
                                style={{
                                    backgroundColor: "#F7F7FD",
                                    fontSize: Utils.returnFontSize(12),
                                    color: AppColors.gray[800],
                                }}
                            >
                                {textHeader.map((header, index) => (
                                    <th
                                        key={index}
                                        className={`p-3 ${index === 0 ? "text-left" : "text-right"}`}
                                        style={{ minWidth: index === 0 ? '200px' : '100px' }}
                                    >
                                        {UIHelper.buildTableColumn(header.title, header.unit)}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(contents) && contents.map((content, index) => (
                                <tr
                                    key={index}
                                    style={{ borderTop: "1px solid #EBEDEF" }}
                                >
                                    <td className="p-3 text-left d-flex gap-2 align-items-center">{content?.name} {content?.additionalComponent}</td>
                                    <td className="p-3 text-right">
                                        {content?.totalRevenue !== null ? Utils.formatNumber(Math.round(content.totalRevenue ?? 0)) : '--'}
                                    </td>
                                    <td className="p-3 text-right">
                                        {content?.commissionRate !== null ? `${Math.round((content.commissionRate ?? 0) * 100)}%` : content?.commissionValue !== null ? Utils.formatNumber(Math.round(content.commissionValue ?? 0)) + ' VNĐ' : '--'}
                                    </td>
                                    <td className="p-3 text-right"
                                        style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}
                                    >
                                        {Utils.formatNumber(Math.round(content.amountReceived ?? 0))}
                                    </td>
                                </tr>
                            ))}
                            {/* Hàng tổng cộng */}
                            <tr style={{ borderTop: "2px solid #EBEDEF", fontWeight: 'bold' }}>
                                <td className="p-3 text-left">Tổng hoa hồng {AgencyHelper.Utils.getShortAgencyRoleName(primaryRole).toLowerCase()} được nhận</td>
                                <td className="p-3 text-right">--</td>
                                <td className="p-3 text-right">--</td>
                                <td className="p-3 text-right">
                                    <div style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}>
                                        {Utils.formatNumber(reconciliationDetail?.netAmount ?? 0)}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    let sampleContents = [
        // { name: 'Dịch vụ môi giới nhà đầu tư góp vốn', totalRevenue: packageResultDetail?.amountSale, commissionRate: packageResultDetail?.basicSaleCommissionRate, amountReceived: packageResultDetail?.basicSaleCommission },
        { name: 'Dịch vụ môi giới nhà đầu tư nhượng quyền', totalRevenue: investorResultDetail?.amountSale, commissionRate: investorResultDetail?.basicSaleCommissionRate, amountReceived: investorResultDetail?.basicSaleCommission },
        { name: 'Dịch vụ môi giới nhà đầu tư liên kết', totalRevenue: coinvestorResultDetail?.amountSale, commissionRate: coinvestorResultDetail?.basicSaleCommissionRate, amountReceived: coinvestorResultDetail?.basicSaleCommission },
        // { name: 'Dịch vụ môi giới tìm kiếm mặt bằng', totalRevenue: null, commissionRate: null, commissionValue: referralResultDetail?.totalReferralCommission, amountReceived: referralResultDetail?.totalReferralCommission },
        // { name: 'Dịch vụ môi giới khách hàng mua trụ sạc', totalRevenue: chargePointResultDetail?.amountSale, commissionRate: chargePointResultDetail?.basicSaleCommissionRate, amountReceived: chargePointResultDetail?.basicSaleCommission },
        { name: 'Hoa hồng tiền điện nhượng quyền', totalRevenue: null, commissionRate: null, commissionValue: investorEnergyResultDetail?.totalEnergyCommission, amountReceived: investorEnergyResultDetail?.totalEnergyCommission },
        { name: 'Hoa hồng tiền điện liên kết', totalRevenue: null, commissionRate: null, commissionValue: coinvestorEnergyResultDetail?.totalEnergyCommission, amountReceived: coinvestorEnergyResultDetail?.totalEnergyCommission },
        {
            name: 'Hoa hồng khác',
            totalRevenue: null,
            commissionRate: null,
            commissionValue: _.sumBy([packageResultDetail, investorResultDetail, coinvestorResultDetail, chargePointResultDetail], 'bonusSaleCommission'),
            amountReceived: _.sumBy([packageResultDetail, investorResultDetail, coinvestorResultDetail, chargePointResultDetail], 'bonusSaleCommission'),
            additionalComponent: (
                <KTTooltip
                    text={`<div><span>Bán NQ: ${Utils.formatNumber(
                        investorResultDetail?.bonusSaleCommission ?? 0
                    )} VNĐ</span><br /><span>Bán liên kết: ${Utils.formatNumber(
                        coinvestorResultDetail?.bonusSaleCommission ?? 0
                    )} VNĐ</span></div>`}
                    textHeader="Thưởng doanh số"
                    isHtmlContent
                >
                    <i
                        className="fa-regular fa-info-circle"
                        style={{ color: AppColors.info }}
                    />
                </KTTooltip>
            )
        },
        { name: `Thuế TNCN (${reconciliationDetail?.taxRate * 100}%)`, totalRevenue: null, commissionRate: null, commissionValue: null, amountReceived: reconciliationDetail?.amount * reconciliationDetail?.taxRate },
    ];

    if (isOrganizationAgency) {
        sampleContents = sampleContents.slice(0, -1);
    }

    return (
        <div>
            <div className="w-100">
                {BreadcrumbHelper.buildBreadcrumb([
                    {
                        title: `Báo cáo đối soát ${AgencyHelper.Utils.getShortAgencyRoleName(primaryRole).toLowerCase()}`,
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    { title: 'Chi tiết báo cáo đối soát' },
                ])}
            </div>

            <div className="m-4 mt-16">
                {/* thong tin Dai ly */}
                <CustomCard
                    showHeader={false}
                    additionalClassName="rounded-lg overflow-hidden"
                    bgTransparent={true}
                    showBorder={false}
                    body={
                        <div className="d-flex flex-column">
                            <div
                                className={`col-12 p-0 h-100`}
                            >
                                {/* thong tin doi soat Dai ly */}
                                <SaleReconciliationInfo />
                            </div>
                            <div
                                className={`col-12 p-0 mt-4 h-100`}
                            >
                                {/* thong tin doi soat */}
                                <ReconciliationInfo
                                    textHeader={[
                                        { title: 'Nội dung đối soát', unit: '' },
                                        { title: 'Tổng doanh thu', unit: 'VNĐ' },
                                        { title: 'Tỷ lệ chia sẻ/hoa hồng', unit: '%/VNĐ' },
                                        { title: 'Số tiền được hưởng', unit: 'VNĐ' },
                                    ]}
                                    contents={sampleContents}
                                />
                            </div>
                            {/* <div className="row px-2 my-2">
                                {cardInfoList.filter(card => card.type === 'card')
                                    ?.map((cardInfo, index) => (
                                        <div className="col-xl-4 col-lg-6 my-2 px-2" key={index}>
                                            <AgencyReconciliationCardView
                                                name={cardInfo.name}
                                                value={cardInfo.value}
                                                unit={cardInfo.unit}
                                                color={cardInfo.color}
                                                icon={cardInfo.icon}
                                                descriptionValue={cardInfo.descriptionValue}
                                            />
                                        </div>
                                    ))}
                            </div> */}
                            <div className="row px-2">
                                {chartInfoList.map((chartInfo, index) => (
                                    <div className="col-xl-6 col-lg-12 mt-4 px-2" key={index}>
                                        <AgencyReconciliationChartView
                                            title={chartInfo.title}
                                            labels={chartInfo.labels}
                                            data={chartInfo.data}
                                            color={chartInfo.color}
                                            backgroundColor={chartInfo.backgroundColor}
                                            valueInfoList={chartInfo.valueInfoList}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                />

                {/* table */}
                {primaryRole === 'SALE'
                    ? (
                        <div className="pt-0">
                            <AppTabs
                                tabs={tabs}
                                activeTab={selectedTab}
                                handleClick={handleSelectedTab}
                                className="mt-2 mr-3"
                                additionalClassName=""
                            />
                            <div
                                className="bg-white shadow"
                                style={{
                                    borderLeft: `1px solid ${AppColors.gray[300]}`,
                                    borderRight: `1px solid ${AppColors.gray[300]}`,
                                    borderBottom: `1px solid ${AppColors.gray[300]}`,
                                    borderRadius: '0px 10px 10px 10px',
                                }}
                            >
                                <AnimatePresence mode="wait">
                                    <motion.div
                                        key={selectedTab}
                                        initial={{ y: 10, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        exit={{ y: -10, opacity: 0 }}
                                        transition={{ duration: 0.2 }}
                                    >
                                        {selectedTab == 'Đại lý mới' && (
                                            <div className="px-5 pb-3 pt-4">{newSalesListView}</div>
                                        )}
                                        {selectedTab == 'NĐT và chủ mặt bằng mới' && (
                                            <div className="px-5 pb-3 pt-4">{newAgenciesListView}</div>
                                        )}
                                    </motion.div>
                                </AnimatePresence>
                            </div>
                        </div>
                    )
                    : (
                        <div className="mt-5 bg-white shadow rounded-lg" >
                            <div className="px-5 pt-4" style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                NĐT và đối tác mới
                            </div>
                            <div className="px-5 pb-3">{newAgenciesListView}</div>
                        </div>
                    )}
            </div>
        </div>
    );
}

export default SaleReconciliationDetailView;
